<template>
  <div class="faq">
    <div class="faq-conten">
        <ul>
          <li v-for="(itembox,index) in dataText" :key="index" @click="showDetails(index,'t')">
            <h5 class="h5"  v-bind:class="{'red-color': itembox.isShow}"><span>■</span> {{ $t(itembox.title) }} </h5>
            <p v-for="(itembox2,index) in itembox.list" v-if="itembox.isShow" :key="index">{{ $t(itembox2.name) }}</p>
          </li>
        </ul>
    </div>

  </div>
</template>
<script>

  export default {
    data(){
      return{
        showIndexList: [],
        showIndexListT: [],
        dataText:[
          {
            title:'contact_18',
            list:[
              {name:'contact_19'}
            ],
            isShow: false
          },
          {
            title:'contact_20',
            list:[
              {name:'contact_21'}
            ],
            isShow: false
          },
          {
            title:'contact_22',
            list:[
              {name:'contact_23'}
            ],
            isShow: false
          },
          {
            title:'contact_24',
            list:[
              {name:'contact_25'}
            ],
            isShow: false
          },
          {
            title:'contact_26',
            list:[
              {name:'contact_27'}
            ],
            isShow: false
          },
          {
            title:'contact_28',
            list:[
              {name:'contact_29'}
            ],
            isShow: false
          },
          {
            title:'contact_30',
            list:[
              {name:'contact_31'}
            ],
            isShow: false
          },
          {
            title:'contact_32',
            list:[
              {name:'contact_33'}
            ],
            isShow: false
          },
          {
            title:'contact_34',
            list:[
              {name:'contact_35'}
            ],
            isShow: false
          },
          {
            title:'contact_36',
            list:[
              {name:'contact_37'}
            ],
            isShow: false
          },
          {
            title:'contact_38',
            list:[
              {name:'contact_39'}
            ],
            isShow: false
          },
          {
            title:'contact_40',
            list:[
              {name:'contact_41'}
            ],
            isShow: false
          },
          {
            title:'contact_42',
            list:[
              {name:'contact_43'}
            ],
            isShow: false
          },
          {
            title:'contact_44',
            list:[
              {name:'contact_45'}
            ],
            isShow: false
          },
          {
            title:'contact_46',
            list:[
              {name:'contact_47'}
            ],
            isShow: false
          },
          {
            title:'contact_48',
            list:[
              {name:'contact_49'}
            ],
            isShow: false
          },
          {
            title:'contact_50',
            list:[
              {name:'contact_51'}
            ],
            isShow: false
          },
          {
            title:'contact_52',
            list:[
              {name:'contact_53'}
            ],
            isShow: false
          },
          {
            title:'contact_54',
            list:[
              {name:'contact_55'}
            ],
            isShow: false
          },
          {
            title:'contact_56',
            list:[
              {name:'contact_57'}
            ],
            isShow: false
          },
        ]
      }
    },
    methods: {
      showDetails: function(index, type) {
        if (type == "t") {
          this.dataText[index].isShow = !this.dataText[index].isShow;
          const obj = {...this.dataText[index]};
          this.$set(this.dataText, index, obj);
        } else {
          var val = !this.showIndexList[index];
          this.$set(this.showIndexList, index, val);
        }
        //this.showIndex=index;
      },
    },
    mounted() {
      if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
        $('body').addClass('Safari');
      }
    }
  };
</script>
<style scoped lang="scss">
  .faq{
    width:96%;
    height:auto;
    margin: 0 auto;
   .faq-conten{
     ul{
       padding: 0;
       li{
         box-sizing: border-box;
         height: auto;
         border-radius: 20px;
         background-color: #FFFFFF;
         box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
          padding: 0 50px 0 30px;
          margin-bottom:30px;
           .h5{
             padding: 31px 0;
             color: #908782;
             cursor: pointer;
             font-size: 20px;
             letter-spacing: 1.25px;
             margin: 0;
             span{
               font-size: 19px;
               margin-right: 2px;
             }
             &.red-color,&:hover{
               color: #000;
               font-weight: bold;
               span{
                 color: #D00717;
               }
             }
           }
           p{
             border-top: 1px solid rgba(151,151,151,0.27);
             padding: 28px 0 35px;
             color: #000000;
             font-size: 18px;
             letter-spacing: 1px;
           }
       }
     }
   }

  }
  .Safari .faq .faq-conten ul li .h5:hover{
    letter-spacing: 0.28px;
  }
  @media (max-width:1080px){
    .faq{
      width: 100%;
      .faq-conten {
        ul{
          padding: 0;
          li {
            padding-left: 15px;
            padding-right: 15px;
            margin-bottom: 16px;
            .h5 {
              padding: 14px 0;
              font-size: 16px;
              letter-spacing: 0.5px;
              line-height: 32px;
              span{
               font-size: 15px;
               margin-right: 2px;
             }
              &.red-color{
                padding-bottom: 8px;
              }
               span{
                 font-size: 14px;
               }
            }
            p{
              font-size: 15px;
              padding-top: 13px;
              letter-spacing: 0.5px;
              line-height: 28px;
              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/default/Faq.vue